(() => {
  const DISCOUNT_QUERY_KEY = "bundle_applied";

  const normalizeCode = (code) => (code || "").trim();

  const isValidCode = (code) => /^[a-zA-Z0-9_-]{1,50}$/.test(code);

  const buildRedirectPath = () => {
    const url = new URL(window.location.href);
    url.searchParams.set(DISCOUNT_QUERY_KEY, "1");
    // url.pathname is ALREADY percent-encoded, and buildDiscountUrl runs the
    // result through encodeURIComponent — so a handle containing a special
    // character gets escaped twice and Shopify redirects to a path that does
    // not exist. /products/efectiv%C2%AE-crossfit-athlete-stack became
    // /products/efectiv%25C2%25AE-crossfit-athlete-stack, i.e. a 404 on every
    // add to cart. Decode first so exactly one round of encoding is applied.
    let path = url.pathname;
    try {
      path = decodeURIComponent(path);
    } catch (error) {
      // Malformed sequence — leave it alone rather than lose the redirect.
    }
    return `${path}${url.search}${url.hash}`;
  };

  const buildDiscountUrl = (code) => {
    const redirectPath = buildRedirectPath();
    return `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`;
  };

  const setFormError = (form, message) => {
    const error = form.querySelector("[data-form-error]");
    if (!error) return;
    error.textContent = message;
    error.classList.toggle("hidden", !message);
  };

  const handleBundleSubmit = async (form) => {
    const code = normalizeCode(form.dataset.bundleDiscountCode);
    if (!code || !isValidCode(code)) return;

    if (form.dataset.bundleSubmitting === "true") return;
    form.dataset.bundleSubmitting = "true";
    setFormError(form, "");

    try {
      const formData = new FormData(form);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json",
        },
        body: formData,
      });

      if (!response.ok) {
        let message = "Unable to add bundle. Please try again.";
        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          const data = await response.json();
          if (data && data.description) message = data.description;
        }
        throw new Error(message);
      }

      window.location.href = buildDiscountUrl(code);
    } catch (error) {
      setFormError(form, error && error.message ? error.message : "Unable to add bundle. Please try again.");
      form.dataset.bundleSubmitting = "false";
    }
  };

  const initBundleBuilder = (root) => {
    if (!root || root.dataset.bundleBuilderInit === "true") return;
    root.dataset.bundleBuilderInit = "true";

    const selects = root.querySelectorAll("[data-bundle-variant-select]");
    for (const select of selects) {
      if (select.dataset.bundleSelectInit === "true") continue;
      select.dataset.bundleSelectInit = "true";
      select.addEventListener("change", () => {
        const item = select.closest("[data-bundle-item]");
        if (!item) return;
        const input = item.querySelector("[data-bundle-item-id]");
        if (input) input.value = select.value;
        // Mirror the chosen flavour onto the parent-line property so it reaches the order.
        const propInput = item.querySelector("[data-bundle-parent-prop]");
        if (propInput) {
          const opt = select.options[select.selectedIndex];
          propInput.value = opt ? opt.textContent.trim() : select.value;
        }
      });
    }

    const form = root.querySelector("[data-bundle-form]");
    if (form && form.dataset.bundleFormInit !== "true") {
      form.dataset.bundleFormInit = "true";
      form.addEventListener("submit", (event) => {
        const code = normalizeCode(form.dataset.bundleDiscountCode);
        if (!code || !isValidCode(code)) return;
        event.preventDefault();
        handleBundleSubmit(form);
      });
    }

    const button = root.querySelector("[data-add-to-cart]");
    if (button && button.dataset.bundleButtonInit !== "true") {
      button.dataset.bundleButtonInit = "true";
      button.addEventListener(
        "click",
        (event) => {
          const form = button.closest("form");
          if (!form) return;
          const code = normalizeCode(form.dataset.bundleDiscountCode);
          if (!code || !isValidCode(code)) return;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          handleBundleSubmit(form);
        },
        true
      );
    }
  };

  const initAll = (scope) => {
    const root = scope || document;
    const builders = root.querySelectorAll("[data-bundle-builder]");
    for (const builder of builders) initBundleBuilder(builder);
  };

  const openDrawerIfBundleApplied = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(DISCOUNT_QUERY_KEY) !== "1") return;

    const url = new URL(window.location.href);
    url.searchParams.delete(DISCOUNT_QUERY_KEY);
    window.history.replaceState({}, "", url.toString());

    // EFECTIV has no "cart:open" listener; open its <cart-drawer> directly,
    // falling back to the header trigger, then to the event DS relies on.
    window.setTimeout(() => {
      const drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.open === "function") { drawer.open(); return; }
      const trigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) { trigger.click(); return; }
      document.dispatchEvent(new CustomEvent("cart:open"));
    }, 60);
  };

  document.addEventListener("DOMContentLoaded", () => {
    initAll(document);
    openDrawerIfBundleApplied();
  });
  document.addEventListener("shopify:section:load", (event) => {
    if (event && event.target) {
      initAll(event.target);
    }
  });
})();
